export default {
  largestTitle: '86px',
  largeTitle: '56px',
  title: '42px',
  smallTitle: '36px',
  smallestTitle: '28px',
  large: '28px',
  default: '26px',
  body: '26px',
  small: '22px',
  smallest: '18px'
};